import React from 'react';
import { Drawer } from 'vaul';
import { Filter } from 'lucide-react';

export type ExchangeFilterOption = 'all' | 'bybit' | 'binance' | 'gate' | 'aster' | 'kucoin' | 'hyperliquid';

const EXCHANGE_OPTIONS: Array<{ value: ExchangeFilterOption; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'bybit', label: 'Bybit' },
  { value: 'binance', label: 'Binance' },
  { value: 'gate', label: 'Gate.io' },
  { value: 'aster', label: 'Aster' },
  { value: 'kucoin', label: 'KuCoin' },
  { value: 'hyperliquid', label: 'Hyperliquid' },
];

interface ExchangeFilterDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedExchange: ExchangeFilterOption;
  onSelect: (exchange: ExchangeFilterOption) => void;
}

export const ExchangeFilterDrawer: React.FC<ExchangeFilterDrawerProps> = ({
  open,
  onOpenChange,
  selectedExchange,
  onSelect,
}) => {
  const handleSelect = (exchange: ExchangeFilterOption) => {
    onSelect(exchange);
    onOpenChange(false);
  };

  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange} repositionInputs={false}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/80 z-[120]" />
        <Drawer.Content
          className="bg-[#1a1b20] flex rounded-t-xl flex-col fixed bottom-0 left-0 right-0 max-h-[65vh] z-[121]"
          style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)' }}
        >
          <div className="px-4 border-b border-gray-500/30 pb-3 pt-2 sticky top-0 bg-secondary z-10">
            <Drawer.Handle className="h-1 w-1/3 mt-0 mb-3 rounded-full" />
            <h2 className="text-md font-bold text-text-primary mb-4">Filter by Exchange</h2>
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-2">
            {EXCHANGE_OPTIONS.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => handleSelect(option.value)}
                className={`w-full py-3 px-4 rounded-lg text-left transition-colors ${
                  selectedExchange === option.value
                    ? 'bg-accent text-white font-semibold'
                    : 'bg-primary/40 border border-gray-600 text-text-primary hover:bg-primary/60'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span>{option.label}</span>
                  {selectedExchange === option.value && (
                    <Filter className="w-4 h-4" />
                  )}
                </div>
              </button>
            ))}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};

